/**
 * Tab nộp dự toán
 * tvanh 02.04.2024
 */
export default {
  EstimateTab: 0,
  ExamineTab: 1,
  EstInitialTab: 2
};